import { useAppDispatch, useAppSelector } from '@store/redux/store';
import { handleSortClick } from '@utils';
import { ListProductsProps } from '../ListProducts';
import {
  FieldHeaderText,
  FieldHeaderWrap,
  FieldTextArrowGroup,
} from '../ListProducts.styles';
import { ArrowSort } from './ArrowSort';

export interface THeaderProps {
  sortString: string;
  label: string;
  // width: number;
  // isCustomField: boolean;
  disabled?: boolean;
  tooltipId?: string;
  tooltipText?: string;
  // isTag?: boolean;
  startSearch: ListProductsProps['startSearch'];
  rightIcon?: React.ReactNode;
}
export function FieldHeader(props: THeaderProps) {
  const {
    sortString,
    label,
    disabled = false,
    tooltipId,
    tooltipText,
    startSearch,
    rightIcon,
  } = props;
  const { filter, mobileStore } = useAppSelector();
  const dispatch = useAppDispatch();
  const isMobile = mobileStore.deviceType.includes('mobile');

  return (
    <FieldHeaderWrap
      data-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      onClick={() => {
        if (!disabled) {
          handleSortClick(
            filter.searchBarText,
            sortString,
            filter.options,
            dispatch,
            startSearch,
          );
        }
      }}
    >
      <FieldTextArrowGroup>
        <FieldHeaderText
          text="p100"
          textColor={isMobile ? 'n700' : 'n600'}
          data-for={tooltipId}
          data-tip={tooltipText}
        >
          {label}
        </FieldHeaderText>
        <ArrowSort
          isSorted={filter.options?.sort === sortString}
          direction={filter.options.direction}
        />
      </FieldTextArrowGroup>
      {rightIcon}
    </FieldHeaderWrap>
  );
  // return (
  //   <Th
  //     // widthPercentage={width}
  //     isActive={
  //       filter.options?.sort === filterString &&
  //       inventory.activeTab === 'equipment'
  //     }
  //   >
  //     <RowDiv
  //       data-tip={tagTip}
  //       data-for={`CustomFieldTooltip-${filterString}`}
  //       onClick={() => {
  //         if (!isCustomField && !isTag)
  //           handleSortClick(
  //             filter.searchBarText,
  //             filterString,
  //             filter.options,
  //             dispatch,
  //             startSearch,
  //           );
  //       }}
  //       isCustomField={isTag || isCustomField}
  //     >
  //       <span>{label}</span>
  //       <ArrowSort headerSort={filterString} />
  //     </RowDiv>
  //

  //   </Th>
  // );
}
